import { useEffect } from 'react';
import { useAuth } from '@/shared/auth';
import { useNavigate } from 'react-router-dom';

export function useLoginViewModel() {
  const navigate = useNavigate();

  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  const handleEmployerLogin = () => {

    // Get OAuth configuration from environment variables
    navigate('/auth/granttoken')
  };

    const handleEmployerLoginMock = () => {

    // Get OAuth configuration from environment variables
    const state = Math.random().toString(36).substring(7);
    sessionStorage.setItem('oauth_state', state);
    navigate(`/auth/granttoken?code=MOCKGRANTCODE_EMPLOYER&state=${state}`);
  };

  const startI9Flow = () => {
    navigate('/sectionOne');
  };

  return {
    startI9Flow,
    handleEmployerLogin,
    handleEmployerLoginMock
  };
}
